import { BpfCloseReasonType } from 'modules/stages';
import { common, green, red } from '@mui/material/colors';
import { BoardColumnEntity } from 'components/shared/Board/types';

import { VOFilters } from '../../filters';
import { BoardDeal, DealPipelineListItem, PipelineColumn } from '../types';
import { Nullable } from '../../../../global';

export function getWonLostColumns(columnsAmount: number | undefined): PipelineColumn[] {
  if (!columnsAmount) return [];

  return [
    {
      id: BpfCloseReasonType.Won,
      name: 'WON',
      ordinal: columnsAmount + 1,
      metaData: {
        isSupportDAD: false,
        nameColor: green[500],
      },
    },
    {
      id: BpfCloseReasonType.Lost,
      name: 'LOST',
      ordinal: columnsAmount + 2,
      metaData: {
        isSupportDAD: false,
        nameColor: red[500],
      },
    },
  ];
}

export function groupVOByStage(
  list: DealPipelineListItem[],
  filters: Nullable<Partial<VOFilters>>
): Record<string, BoardDeal[]> {
  return list.reduce<Record<string, BoardDeal[]>>((acc, { stage, deal }) => {
    if (filters?.CLOSED_DEALS?.isIncludeClosedDeals && deal.closeStatus === 'SUCCESS') {
      const mapKey = BpfCloseReasonType.Won;

      if (acc[mapKey]) acc[mapKey].push({ ...deal, flowId: stage.businessProcessFlowId });
      else acc[mapKey] = [{ ...deal, flowId: stage.businessProcessFlowId }];

      return acc;
    }

    if (filters?.CLOSED_DEALS?.isIncludeClosedDeals && deal.closeStatus === 'FAILED') {
      const mapKey = BpfCloseReasonType.Lost;

      if (acc[mapKey]) acc[mapKey].push({ ...deal, flowId: stage.businessProcessFlowId });
      else acc[mapKey] = [{ ...deal, flowId: stage.businessProcessFlowId }];

      return acc;
    }

    const mapKey = stage.name;

    if (acc[mapKey]) acc[mapKey].push({ ...deal, flowId: stage.businessProcessFlowId });
    else acc[mapKey] = [{ ...deal, flowId: stage.businessProcessFlowId }];

    return acc;
  }, {});
}

export function generateBoardColumns(
  stages: PipelineColumn[],
  filters: Nullable<Partial<VOFilters>>,
  groupedVOs: Record<string, BoardDeal[]>
): BoardColumnEntity<BoardDeal>[] {
  return [...stages, ...(filters?.CLOSED_DEALS?.isIncludeClosedDeals ? getWonLostColumns(stages.length) : [])]
    .toSorted((stage1, stage2) => stage1.ordinal - stage2.ordinal)
    .map(stage => ({
      id: stage.id,
      title: stage.name,
      cards: groupedVOs[stage.name] ?? [],
      metaData: {
        isSupportDAD: true,
        nameColor: common.black,
        ...(stage?.metaData ? stage.metaData : {}),
        ...(Object.values(BpfCloseReasonType).includes(stage.id as BpfCloseReasonType) ? { isSupportDAD: false } : {}),
      },
    }));
}
